

















































































import { computed, defineComponent, reactive, ref, watch } from '@vue/composition-api';
import _ from 'lodash';
import { SubmitContext } from 'tdesign-vue';

// 引入 compositions
import userValidator from '@/renderer/components/user/compositions/userValidator';
import userActionHandler, {
  ExtUserInfo,
} from '@/renderer/views/desktop/ManageConsole/UserManagement/externalUser/compositions/userActionHandler';

// 引入工具类
import phonePrefixOptions from '@/renderer/scripts/utils/phonePrefix';
import { phonePrefixFilter } from '@/renderer/common/phoneUtils';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import { phoneCompose } from '@/renderer/scripts/utils/tools';
import tips from '@/renderer/scripts/utils/tips';
const defaultUserInfo = {
  userId: -1,
  nickname: '',
  countryCode: '+86',
  phoneNumber: '',
  comment: '',
  allowSms: true,
};
export default defineComponent({
  name: 'importExtUserDialog',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object as () => ExtUserInfo,
      required: true,
    },
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const { methods: userMethods } = userActionHandler();
    // user传递过来有默认值
    const formData = reactive<ExtUserInfo>(_.cloneDeep(defaultUserInfo));
    const operType = computed(() => {
      return props.user.phoneNumber.length && props.user.phoneNumber.length > 0 ? 'edit' : 'add';
    });
    const phoneDisable = computed(() => {
      return props.user.phoneNumber.length > 0;
    });
    const phoneMaxLen = computed(() => (formData.countryCode === '+86' ? 11 : 20));
    const allRules = computed(() => {
      const { rules } = userValidator(formData, operType.value === 'edit' ? ['phoneNumber'] : undefined);
      return rules;
    });
    const { nicknameMaxLength, commentMaxLength } = ConstantConfig;
    const validated = ref(true);
    const required = computed(() => formData.phoneNumber && formData.nickname);
    const formChanged = computed(() => {
      if (operType.value === 'add') return true;
      const initUserInfo = props.user;
      return formData.nickname !== initUserInfo.nickname || formData.comment !== initUserInfo.comment;
    });
    const methods = {
      // 点击确认
      onConfirm() {
        (context.refs.form as any).submit();
      },
      // 点击取消
      onClose() {
        context.emit('update:show', false);
      },
      phonePrefixFilter,
      phoneCompose,
      // 手机前缀改变
      handleCodeChange(val: any) {
        if (formData.phoneNumber && formData.phoneNumber.length > phoneMaxLen.value) {
          formData.phoneNumber = formData.phoneNumber.substring(0, phoneMaxLen.value);
        }
      },
      async confirm() {
        if (operType.value === 'add') {
          const result = await userMethods.addUser(formData);
          if (result) {
            context.emit('update:show', false);
            context.emit('refresh'); // 把数据发送给调用方处理
          }
        } else {
          const result = await userMethods.editUser(formData);
          if (result) {
            context.emit('update:show', false);
            context.emit('refresh'); // 把数据发送给调用方处理
          }
        }
      },

      submit({ validateResult, firstError }: SubmitContext<FormData>): void {
        if (validateResult !== true) {
          tips.warning(firstError as string);
          return;
        }
        this.confirm();
      },
    };
    watch(innerShow, val => {
      if (val) {
        Object.assign(formData, props.user);
      } else {
        Object.assign(formData, defaultUserInfo);
      }
    });
    return {
      innerShow,
      formData,
      operType,
      allRules,
      phoneMaxLen,
      validated,
      required,
      formChanged,
      phoneDisable,
      nicknameMaxLength,
      commentMaxLength,
      phonePrefixOptions,
      ...methods,
    };
  },
});
